import { useEffect, useState } from 'react';
import './CookieBanner.css';
import { Button, Modal } from 'react-bootstrap';
import { useCreateUserMutation } from '../api/services/userService';
import * as authHelper from '../helpers/authHelper';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CookieBanner = () => {
    const [show, setShow] = useState({
        banner: true,
        cookieNotice: false,
        spinner: false,
    });
    const user = authHelper.getUserFromSession();
    const [updateUser] = useCreateUserMutation();

    useEffect(() => {
        const cookieBannerIgnore = localStorage.getItem('cookie_banner_ignore');
        if ((user && user.isCookieConsent === true) || cookieBannerIgnore === 'true') {
            setShow({ ...show, banner: false });
        }
    }, []);

    const handleAccept = () => {
        setShow({ ...show, spinner: true });
        updateUser({ ...user, isCookieConsent: true })
            .unwrap()
            .then(() => {
                authHelper.setLoggedInUser({ ...user, isCookieConsent: true });
                toast.success('Cookie accepted successfully');
                setShow({ ...show, banner: false, spinner: false });
            })
            .catch(() => {
                toast.error('Something went wrong, while trying to accept the cookie, try again');
            });
    };

    const closeCookieBanner = () => {
        authHelper.setCookieBannerIgnore();
        setShow({ ...show, banner: false });
    };

    const openCookieNotice = () => {
        setShow({ ...show, cookieNotice: true });
    };

    const closeCookieNotice = () => {
        setShow({ ...show, cookieNotice: false });
    };

    return (
        <>
            <ToastContainer autoClose={3000} />
            {show.banner ? (
                <div>
                    <div id="bottom-banner" className="cookie-banner bottom-banner">
                        <div className="">
                            <div className="d-flex align-items-center flex-row justify-content-between flex-wrap gap-3">
                                <div className="cookie-content">
                                    <div className="d-flex flex-row align-items-center mb-2">
                                        <span className="cookie-icon me-2">🍪</span>
                                        <h6 className="mb-0 fw-bold m-0">Cookie Consent</h6>
                                    </div>
                                    <p className="mb-0 text-muted text-start">
                                        By continuing to use the Epiq Document Delivery Portal application, you consent
                                        to the storing of first- and third- party cookies on your device for application
                                        performance, to analyze site usage, and assist in Epiq's marketing efforts. View
                                        our{' '}
                                        <a onClick={openCookieNotice} class="link-primary cookie-cursor">
                                            Cookie Notice
                                        </a>
                                    </p>
                                </div>
                                <div className="mb-3 mr-3">
                                    <Button
                                        type="button"
                                        className="margintop29"
                                        onClick={handleAccept}
                                        disabled={show.spinner}>
                                        {show.spinner ? (
                                            <div
                                                class="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"></div>
                                        ) : null}{' '}
                                        Accept Cookies
                                    </Button>
                                    <span className="float-end noti-close-btn cookie-cursor">
                                        <i
                                            className="mdi mdi-close"
                                            onClick={show.spinner ? undefined : closeCookieBanner}></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CookieNotice openNotice={show.cookieNotice} closeCookieNotice={closeCookieNotice} />
                </div>
            ) : (
                <></>
            )}
        </>
    );
};

const CookieNotice = ({ openNotice, closeCookieNotice }) => {
    return (
        <Modal
            show={openNotice}
            size="lg"
            scrollable="true"
            className="modalStyle"
            contentClassName="cookie-notice-height">
            <Modal.Header>
                <h4 className="modal-title fw-bold">Cookie Notice</h4>
                <i className="mdi mdi-close cookie-cursor" onClick={() => closeCookieNotice()}></i>
            </Modal.Header>
            <Modal.Body>
                <h5>Cookie Notice for Delivery Portal (deliveryportal.epiqglobal.com)</h5>
                <span>Effective Date: 9/1/2025</span>
                <p className="mt-1">
                    This Cookie Notice explains how Epiq Systems, Inc. ("we", "us", or "our") uses cookies and similar
                    technologies on the Delivery Portal website located at{' '}
                    <a href="https://deliveryportal.epiqglobal.com">https://deliveryportal.epiqglobal.com"</a> ("Site").
                </p>
                <h5>What Are Cookies?</h5>
                <p>
                    Cookies are small text files that are placed on your device when you visit a website. They help the
                    site recognize your device and store information about your preferences or past actions.
                </p>
                <h5>Why We Use Cookies</h5>
                <p>We use cookies to:</p>
                <ul>
                    <li> • Ensure the proper functioning of the Site</li>
                    <li>• Enhance user experience and security (e.g., two-factor authentication)</li>
                    <li>• Analyze traffic and usage patterns</li>
                    <li>• Support document submission workflows and case validation features </li>
                </ul>
                <h5>Types of Cookies We Use</h5>
                <ul>
                    <li>
                        • <span className="fw-bold">Essential Cookies:</span>
                        Required for the Site to function properly (e.g., login sessions, password resets).
                    </li>
                    <li>
                        • <span className="fw-bold">Performance Cookies:</span> Help us understand how users interact
                        with the Site.
                    </li>
                    <li>
                        • <span className="fw-bold">Functional Cookies:</span> Remember user preferences and settings.
                    </li>
                    <li>
                        • <span className="fw-bold">Security Cookies:</span> Support multi-factor authentication and
                        protect user data.
                    </li>
                </ul>
                <h5>Managing Cookies</h5>
                <p>
                    You can manage or disable cookies through your browser settings. However, disabling essential
                    cookies may affect your ability to use certain features of the Site.
                </p>
                <h5>Updates to This Notice</h5>
                <p>
                    We may update this Cookie Notice from time to time. Changes will be posted on this page with an
                    updated effective date.
                </p>
                <h5>Contact Us</h5>
                <p>If you have questions about this Cookie Notice or our use of cookies, please contact us at:</p>
                <h5>Delivery Portal Support</h5>
                <p>
                    Email:{' '}
                    <a href="mailto:DeliveryPortalSupport@epiqglobal.com">DeliveryPortalSupport@epiqglobal.com</a>
                </p>
            </Modal.Body>
        </Modal>
    );
};
export default CookieBanner;
